import { useNavigate } from 'react-router-dom';
import { ACTIVITY_DETAILS_RADIUS, ACTIVITY_DETAILS_RESPONSIVE, ACTIVITY_DETAILS_TYPOGRAPHY } from './constants';

export interface ActivityTopBarProps {
  recommendedFor?: {
    name: string;
    avatarUrl: string;
  };
}

/**
 * ActivityTopBar Component
 * 
 * Top bar with "Recommended for [Name]" on left and "DONE" button on right.
 * The Done button navigates back to the previous page.
 * 
 * Design specs:
 * - Height: 52px
 * - Background: White
 * - Padding: 24px horizontal, 24px from top
 * - Child avatar: 16x16px circle
 * - Text: DM Sans Medium 12px, #1B2831
 * - "Sam" is bold
 * - DONE: DM Sans Black 12px, uppercase, 0.72px letter spacing
 * 
 * Note: Sticky positioning is handled by ActivityDetailsLayout
 */
export default function ActivityTopBar() {

  const navigate = useNavigate();

  const handleDoneClick = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <div 
      className={`${ACTIVITY_DETAILS_RESPONSIVE.horizontalPadding} pt-6 bg-white`}
      style={{ 
        //backgroundColor: HOME_V2_COLORS.headerBackground,
        borderTopLeftRadius: `${ACTIVITY_DETAILS_RADIUS.container}px`,
        borderTopRightRadius: `${ACTIVITY_DETAILS_RADIUS.container}px`,
      }}
    >
      <div className="flex items-center justify-end h-full">
        {/* Done Button */}
        <button
          onClick={handleDoneClick}
          className={`font-black uppercase ${ACTIVITY_DETAILS_TYPOGRAPHY.topBarDoneButton}`}
          style={{
            fontFamily: 'DM Sans, sans-serif',
            letterSpacing: '0.72px',
            color: '#000000',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Done
        </button>
      </div>
    </div>
  );
}

      //   {/* Recommended For */}
      //   {
      //     recommendedFor ? (
      //   <div className="flex items-center gap-2">
      //     {/* Child Avatar */}
      //     <img
      //       src={recommendedFor.avatarUrl}
      //       alt={`${recommendedFor.name}'s avatar`}
      //       className="rounded-full object-cover"
      //       style={{
      //         width: '16px',
      //         height: '16px',
      //       }}
      //     />
      //     {/* Text */}
      //     <span
      //       className={`font-medium ${ACTIVITY_DETAILS_TYPOGRAPHY.topBarRecommendedText}`}
      //       style={{
      //         fontFamily: 'DM Sans, sans-serif',
      //         color: ACTIVITY_DETAILS_COLORS.textPrimary,
      //       }}
      //     >
      //       Recommended for{' '}
      //       <span className="font-bold">{recommendedFor.name}</span>
      //     </span>
      //   </div>
      // ): <div/>}
